// extracted by mini-css-extract-plugin
module.exports = {"column":"columns_column__RTfa1"};